import React, { useEffect } from 'react';
import { useDisclosure } from '@mantine/hooks';
import i18n from '@/utils/i18n';
import { useState } from 'react';
import { allCapsToNormal } from '@/utils/stringHelper';
import { FaSave } from 'react-icons/fa';
import { Communicator } from '../../tools/Communication';
import { LayoutStoreInstance } from '../../LayoutStore';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ClassicLoadingSpinner from '../../components/LoadingSpinner/ClassicLoadingSpinner';
import { RoleToClaim } from '../../contants';

type SelectClaimModalProps = {
  userClaimIn: string;
  userUuid: string;
  onUserClaimSaveSuccess: (newClaim: string) => any;
};

export function SelectClaimModal({
  userClaimIn,
  userUuid,
  onUserClaimSaveSuccess,
}: SelectClaimModalProps) {
  const [opened, handlers] = useDisclosure(false);

  const [userClaim, setUserClaim] = useState(userClaimIn);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userClaimIn) {
      setUserClaim(userClaimIn);
    }
  }, [userClaimIn]);

  const options = Object.keys(RoleToClaim).map((role) => ({
    value: (RoleToClaim as any)[role],
    label: allCapsToNormal(role),
  }));

  async function saveUserClaim() {
    setLoading(true);

    const res = await Communicator.PostData('/Users/SetUserClaim', {
      userId: userUuid,
      claimType: userClaim,
    });

    if (res.status !== 200) {
      LayoutStoreInstance.setError('Failed to update user claim');
    } else {
      onUserClaimSaveSuccess(userClaim);
      LayoutStoreInstance.setSuccess('Successfully updated user claim');
    }
    handlers.close();

    setLoading(false);
  }

  return (
    <>
      <Modal isOpen={opened} toggle={handlers.toggle} onClosed={handlers.close}>
        <ModalHeader toggle={handlers.toggle}>
          {i18n.t('User:selectClaim')}
        </ModalHeader>
        <ModalBody>
          <div className="input-group mb-1">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">
                {i18n.t('User:claim')}:
              </span>
            </div>
            <select
              className="form-control"
              value={userClaim}
              onChange={({ target: { value } }) =>
                setUserClaim(value || userClaim)
              }
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <br className="mt-2" />
          <span>
            {i18n.t(`User:claim${userClaim.toUpperCase()}Description`)}
          </span>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handlers.close}>
            {i18n.t('Common:cancel')}
          </Button>
          <Button
            disabled={loading}
            onClick={saveUserClaim}
            rightIcon={<FaSave />}
          >
            {loading && <ClassicLoadingSpinner />}
            {!loading && i18n.t('Common:save')}
          </Button>
        </ModalFooter>
      </Modal>

      <Button color="link" onClick={handlers.open}>
        {i18n.t('User:selectClaim')}
      </Button>
    </>
  );
}
